import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { format, parseISO } from 'date-fns'
import styles from './styles'
import { ChevronLink, EpisodeInfoIcons, Placeholder } from '..'
import { colors } from '../../styles'

const EpisodeInfo = ({
  programmeGuid,
  name,
  title,
  summary,
  startTime,
  duration,
  availableUntil,
  hasSubtitles,
  hasMoreEpisodes,
  hasInfoText,
  hasGuidanceText,
  isLoading,
}) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])
  if (!mounted) {
    return null // return this null to avoid hydration errors
  }

  if (isLoading) {
    return (
      <div className="EpisodeInfo">
        <h1 className="name">
          <Placeholder width="60%" height="2rem" />
        </h1>
        <p>
          <Placeholder />
        </p>
        <p className="summary">
          <Placeholder height="3rem" />
        </p>
        <p className="available-until-row">
          <Placeholder width="50%" />
        </p>
        <div className="icons">
          <Placeholder width="30%" height="1.5rem" />
        </div>
        <div className="more-episodes">
          <Placeholder width="40%" />
        </div>
        <style jsx>{styles}</style>
      </div>
    )
  }

  return (
    <div className="EpisodeInfo">
      <h1 className="name">{name}</h1>
      <p>
        <span className="title" data-testid="programme-title">{title}</span>
        <span className="duration">{duration}</span>
      </p>
      <p className="summary">{summary}</p>
      {availableUntil && (
        <p className="available-until-row">
          <span className="available-until">Available until: </span>
          <span className="expiry-date">
            {format(parseISO(availableUntil), 'd MMM yy, HH:mm')}
          </span>
        </p>
      )}
      <EpisodeInfoIcons
        hasGuidanceText={hasGuidanceText}
        hasSubtitles={hasSubtitles}
        hasInfoText={hasInfoText}
      />
      {programmeGuid && (
        <div className="more-episodes">
          <ChevronLink
            href={`/summary/${programmeGuid}`}
            uppercase
            color={colors.textHoverPurple}
          >
            {hasMoreEpisodes
              ? 'More episodes available'
              : 'Find out more about this programme'}
          </ChevronLink>
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  )
}

EpisodeInfo.propTypes = {
  programmeGuid: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string.isRequired,
  summary: PropTypes.string,
  startTime: PropTypes.string,
  duration: PropTypes.string.isRequired,
  availableUntil: PropTypes.string,
  hasSubtitles: PropTypes.bool,
  hasMoreEpisodes: PropTypes.bool,
  hasInfoText: PropTypes.bool,
  hasGuidanceText: PropTypes.bool,
  isLoading: PropTypes.bool,
}

EpisodeInfo.defaultProps = {
  programmeGuid: '',
  name: '',
  summary: '',
  startTime: '',
  availableUntil: '',
  hasSubtitles: false,
  hasInfoText: false,
  hasGuidanceText: false,
  hasMoreEpisodes: false,
  isLoading: false,
}

export default EpisodeInfo
